import axios from 'axios';
import querystring from 'querystring';
import { awsUrl, url } from '../../axiosInstance';
import * as actionType from '../store/action';
import showAlert from './ShowAlert';
import { setPreload } from './CartsOpen';
import { GetStationsToUser } from './Station';
let token;

export const LogOut = () => {
    return dispatch => {
        localStorage.removeItem('token');
        dispatch({ type: actionType.LOGOUT })
    }
}

export const loginPost = (isUser, password) => {
    return dispatch => {
        axios.get(`${awsUrl}/v1/user`, {
            headers: {
                'Authorization': `bearer ${localStorage.token}`,
            },
        })
            .then(x => {
                GetStationsToUser(x.data?.Id).then((x) => {
                    dispatch(updateStationId(x.data[0]?.Id));
                });
                if (x.data.UserTypeId !== 5)
                    if (x.data.IsEmailVerified || x.data.UserTypeId) {
                        dispatch({
                            type: actionType.LOGIN,
                            payload: {
                                user: x.data,
                                role: x.data.UserTypeId < 4,
                            }
                        })
                    }
                    else {
                        token = localStorage.token
                        localStorage.removeItem('token');
                        dispatch({
                            type: actionType.VERIFIED_EMAIL,
                            payload: {
                                customerId: x.data.Id,
                                Email: x.data.Phone,
                                Password: password,
                                passwordMail: x.data.passwordMail,
                            }
                        })
                    }

            })

            .catch(() => {
                localStorage.removeItem('token');
                if (isUser) {
                    showAlert({ msgTitle: "שם משתמש וסיסמה שגויים", msgType: "error" })
                }
            })
    }
}
export const PutCustomer = (data) => {
    return dispatch => {
        axios.put(`${awsUrl}/v1/customers`, data, {
            headers: {
                'Authorization': `bearer ${localStorage.token}`,
            },
        })
            .then(x => {
                dispatch({
                    type: actionType.LOGIN,
                    payload: {
                        user: x.data,
                        role: false,
                    }
                })

            }).finally(c => dispatch(setPreload(false)))
    }
}

export const UpdateCustomerStationId = (customerId, stationId) => {
    return dispatch => {
        axios.post(`${url}customer/station?Id=${customerId}&StationId=${stationId}`, null, {
            headers: {
                'Authorization': `bearer ${localStorage.token}`,
                "Access-Control-Allow-Origin": "*"
            },
        })
        .then(response => {
            dispatch({
                type: actionType.UPDATE_STATION_ID,
                payload: stationId, 
            });
        })
        .catch(error => {
            console.error('Error updating Station ID:', error);  
        })
        .finally(() => dispatch(setPreload(false)));
    };
};


export const sendVerifiedMail = () => {
    return axios.put(`${awsUrl}/v1/customers`, {IsEmailVerified: 1}, {
        headers: {
            'Authorization': `bearer ${token}`,
        },
    })
}
export const loginToken = (data, isUser) => {
    return dispatch => {
        axios.post(`${awsUrl}/v1/login`, data)
            .then(x => {
                localStorage.setItem('token', x.data.access_token)
                dispatch(loginPost(isUser, data.password))
            })
            .catch(() => showAlert({ msgTitle: "שגיאה", msgType: "error" }))

    }
}

export const customerRegister = (val) => {
    return dispatch => {
        axios.post(`${awsUrl}/v1/register`, val)
            .then(x => {
                dispatch({
                    type: actionType.VERIFIED_EMAIL,
                    payload: {
                        customerId: x.data.Id,
                        Email: val.Email,
                        Password: val.password,
                        passwordMail: x.data.Name,
                    }
                })
            })
            .catch(err => {
                const errMsg = "לא הצלחנו להקים את הלקוח נסה במועד מאוחר יותר";
                showAlert({ msgTitle: err.response.data.Message ? err.response.data.Message : errMsg })
            })
            .finally(() => dispatch(setPreload(false)));

    }
}

export const sendPassword = (email) => {
    return dispatch => {
        axios.get(`${url}Customer?Email=${email}`)
            .then(x => {
                showAlert({ msgTitle: 'נשלח לך מייל', msgType: 'success' })

            })
            .catch(err => showAlert({ msgTitle: 'לא מצאנו את הכתובת מייל במערכת', msgType: "error" }))
            .finally(() => dispatch(setPreload(false)));
    }
}

export const ChangPassword = (data) => {
    return dispatch => {
        dispatch(setPreload(true));
        axios.post(`${awsUrl}/v1/changePassword`, data).then(x => {
                if (x.data) {
                    showAlert({ msgTitle: 'הסיסמה עודכנה בהצלחה', msgType: "success" })
                }
                else {
                    throw new Error()
                }
            })
            .catch(err => showAlert({ msgTitle: 'קוד האיפוס אינו תקין', msgType: "error" }))
            .finally(() => dispatch(setPreload(false)));
    }
}

export const setUserEntry = (value) => {
    return dispatch => dispatch({ type: actionType.USER_ENTRY, payload: value })
}

export const getAllCustomer = () => {
    return axios.get(`${awsUrl}/v1/customers`,
        {
            headers: {
                'Authorization': `bearer ${localStorage.token}`,
            }
        })

}

export const updateStationId = (value) => {
    return dispatch => dispatch({ type: actionType.UPDATE_STATION_ID, payload: value })
};